// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__Tgupp","conteiner":"loader_conteiner__0vPdd","img_block":"loader_img_block__57qoF","logo_block":"loader_logo_block__XZrts"};